import React from "react"
import { withRouter } from "react-router"
import classNames from "classnames"
import auth from "../../auth"
import { FormattedMessage, injectIntl } from "react-intl"
import { default as sharedMessages } from "../../messages"
import { default as profileMessages } from "../../messages/profile"
import settingsMessages from "../../messages/settings"
import { getAccountSettings } from "../../scripts/accountSettings"
import Image from "../elements/Image"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"

class PasswordReset extends React.Component {
  state = {
    email: "",
    loading: false,
    emailSent: false,
    errors: {}
  }

  changeField = evt => {
    if (evt) evt.preventDefault()

    const { value, name } = evt.target
    this.setState({
      [name]: value
    })
  }

  onSubmit = evt => {
    if (evt) evt.preventDefault()
    const { intl } = this.props
    const { email } = this.state

    this.setState({ loading: true })

    auth
      .resetPassword(email)
      .then(res => {
        this.setState({
          emailSent: true,
          loading: false,
          errors: {}
        })
      })
      .catch(err => {
        this.setState({
          errors:
            err.json && err.json.errors
              ? err.json.errors
              : {
                  error: intl.formatMessage(sharedMessages.somethingWentWrong)
                },
          loading: false,
          email: ""
        })
      })
  }

  render() {
    const { intl } = this.props
    const { email, errors, emailSent } = this.state
    const accountSettings = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )
    const styleBodyType = accountSettings.settings.style.content || ""

    return (
      <main id="main" role="main" tabIndex={0} data-componant="Login">
        {styleBodyType === "default" && (
          <Image
            className="p-offpage__border"
            src="/images/offpage-border.png"
            alt="Vintage border"
          />
        )}

        {getStyleTag("form-message")}

        {styleBodyType === "default" && (
          <div className="row" id="item-info">
            <div className="small-12 columns">
              <h1 className="beta mbt">
                <FormattedMessage {...sharedMessages.formResetPassword} />
              </h1>
            </div>
          </div>
        )}

        <div className="row" id="item-info">
          {/*<div className="small-12 medium-7 columns auth__main-column">*/}
          {styleBodyType !== "default" ? (
            <div className="title" style={getStyles("p-offpage__title")}>
              Reset Password
            </div>
          ) : null}

          <div className="small-12 columns auth__main-column">
            <form
              onSubmit={this.onSubmit}
              className={classNames("form--can-load", {
                "state-form-loading": this.state.loading
              })}
            >
              {!emailSent && (
                <div>
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={this.changeField}
                    placeholder={intl.formatMessage(
                      sharedMessages.emailDefault
                    )}
                    required
                  />
                  {errors.email && (
                    <span className="form-message state-error">
                      {errors.email}
                    </span>
                  )}
                </div>
              )}

              {emailSent && (
                <p>
                  <FormattedMessage
                    {...profileMessages.passwordResetEmailSent}
                  />
                </p>
              )}

              {!!errors.error && (
                <div className="form-message state-error">{errors.error}</div>
              )}

              {!emailSent && (
                <div className="vertical-align-middle">
                  <button
                    className={classNames("button man button--can-load", {
                      "state-loading": this.state.loading
                    })}
                    type="submit"
                    style={getStyles("p-offpage__form__button")}
                  >
                    <FormattedMessage {...profileMessages.sendResetEmail} />
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>
      </main>
    )
  }
}

export default withRouter(injectIntl(PasswordReset))



// WEBPACK FOOTER //
// ./webapp/components/pages/PasswordReset.js